export default function AssetFilterSortBar({
  filter,
  setFilter,
  sort,
  setSort,
  paymentFilter,
  setPaymentFilter
}) {
  const hasPaymentFilter = typeof setPaymentFilter === "function";

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 bg-white p-3 sm:p-4 rounded-xl border gap-3">
      {/* Status Filters */}
      <div className="flex gap-1.5 sm:gap-2 flex-wrap">
        {["all", "expired", "expiring", "upcoming", "valid"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`group relative px-2.5 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium rounded-lg sm:rounded-xl border sm:border-2 transition-all duration-200 transform hover:-translate-y-0.5 active:translate-y-0 ${
              filter === f
                ? "bg-gradient-to-r from-blue-600 to-blue-700 text-white border-blue-600 shadow-lg shadow-blue-500/30"
                : "bg-white text-gray-600 border-gray-300 hover:border-gray-400 hover:bg-gray-50 shadow-sm hover:shadow-md"
            }`}
          >
            <span className="relative z-10 whitespace-nowrap">
              {f === "all"
                ? "All"
                : f === "expired"
                ? "Expired"
                : f === "expiring"
                ? "Expiring"
                : f === "upcoming"
                ? "Upcoming"
                : "Valid"}
            </span>
          </button>
        ))}
      </div>

      {/* Payment Filter (Subscriptions only) + Sorting */}
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
        {hasPaymentFilter && (
          <select
            value={paymentFilter || "all"}
            onChange={(e) => setPaymentFilter(e.target.value)}
            className="flex-1 sm:flex-none min-w-0 border sm:border-2 border-gray-300 rounded-lg sm:rounded-xl px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm font-medium bg-white hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <option value="all">All Payments</option>
            <option value="card">Card</option>
            <option value="netbanking">Net Banking</option>
            <option value="upi">UPI</option>
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="other">Other</option>
            <option value="none">No Info</option>
          </select>
        )}

        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="flex-1 sm:flex-none min-w-0 border sm:border-2 border-gray-300 rounded-lg sm:rounded-xl px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium bg-white hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm hover:shadow-md"
        >
          <option value="name">Sort by Name</option>
          <option value="priority">Sort by Status</option>
          <option value="expiry">Nearest Expiry</option>
        </select>
      </div>
    </div>
  );
}

